var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1793 0C48.7094 0 62.1066 13.3971 62.1066 29.9273C62.1066 46.4574 48.7094 59.8546 32.1793 59.8546C15.6492 59.8546 2.25201 46.4574 2.25201 29.9273C2.25201 13.3971 15.6492 0 32.1793 0Z",
    fill: "url(#paint0_radial_166_909)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2721 23.1118C27.2927 17.2315 37.0658 17.2315 43.0863 23.1118L43.8111 23.8249C44.1151 24.1172 44.1151 24.5965 43.8111 24.8887L41.3328 27.3086C41.1808 27.4606 40.9353 27.4606 40.7833 27.3086L39.7896 26.3383C35.5811 22.235 28.7773 22.235 24.5688 26.3383L23.505 27.3788C23.353 27.5307 23.1075 27.5307 22.9555 27.3788L20.4772 24.9589C20.1732 24.6666 20.1732 24.1873 20.4772 23.895L21.2721 23.1118ZM48.2184 28.1153L50.4279 30.2663C50.7318 30.5585 50.7318 31.0378 50.4279 31.3301L40.4794 41.0448C40.1754 41.337 39.6844 41.337 39.3922 41.0448L32.3312 34.1475C32.2611 34.0773 32.1325 34.0773 32.0623 34.1475L25.0014 41.0448C24.6974 41.337 24.2064 41.337 23.9142 41.0448L13.9306 31.3301C13.6266 31.0378 13.6266 30.5585 13.9306 30.2663L16.1401 28.1153C16.444 27.823 16.935 27.823 17.2273 28.1153L24.2882 35.0126C24.3584 35.0827 24.487 35.0827 24.5571 35.0126L31.6181 28.1153C31.922 27.823 32.413 27.823 32.7053 28.1153L39.7663 35.0126C39.8364 35.0827 39.965 35.0827 40.0351 35.0126L47.0961 28.1153C47.4234 27.823 47.9144 27.823 48.2184 28.1153Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_166_909",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.2522 29.9282) scale(59.8546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/WalletConnect.ba31edabcb5235b77ba7382d66fbbc2d.svg";
export { ForwardRef as ReactComponent };